import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Typography, CircularProgress } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Pendingwarning } from 'component/BuyersMarketplace/Marketplaceicons';
import { OrangePendingwarning } from 'component/BuyersMarketplace/Marketplaceicons';
import Sample from 'assets/dummy/Sample.pdf';
import { DownArrowIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import ssl from 'assets/images/ssl.png';
import { DateIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import { CreditCardIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import { EFTicon } from 'component/BuyersMarketplace/Marketplaceicons';
import { ZeptoIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import { BpayIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import { CryptoIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import { GreenLock } from 'component/BuyersMarketplace/Marketplaceicons';
import { PdfIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import { Share } from 'component/BuyersMarketplace/Marketplaceicons';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import { postApiCall } from 'api/apiService';
import {
  BUYER_VIEW_DEPOSIT_DETAILS,
  REQUEST_DEPOSIT_DETAILS,
} from 'constant/app.config';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import DepositEftPdf from './DepositEftPdf';
import Loading from 'assets/images/loading.png';

export default function DepositPaymentDetailsNew({
  open,
  setDepositeopen,
  data,
  getBuyerIndividualValue,
  setPaymentPop,
  setTabDAta,
  handleMakeOfferClick,
}) {
  const [secureOpen, setSecureOpen] = useState(false);
  const propertyId =
    getBuyerIndividualValue?.PropertyDetails?.property?.propertyId;
  const address =
    getBuyerIndividualValue?.PropertyDetails?.propertyAddress?.streetName;
  const offerPrice =
    getBuyerIndividualValue?.PropertyDetails?.offerStatus?.price;
  const localdata = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(localdata);
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const paymentOptions = [
    {
      label: 'Credit Card',
      description: 'Credit card fees apply',
      icon: <CreditCardIcon />,
    },
    {
      label: 'EFT',
      description: '',
      icon: <EFTicon />,
    },
    {
      label: 'Zepto Payment',
      description: 'Free and instant',
      icon: <ZeptoIcon />,
    },
    {
      label: 'BPay',
      description: '',
      icon: <BpayIcon />,
    },
    {
      label: 'Crypto',
      description: 'Coming Soon',
      icon: <CryptoIcon />,
    },
  ];

  const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
    '& .MuiSvgIcon-root': {
      display: 'none',
    },
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#C4C4C438',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#C4C4C438',
    },
    '&.Mui-checked': {
      backgroundColor: '#6C2AD2',
      position: 'relative',
    },
    '&.Mui-checked::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '10px',
      height: '8px',
      background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M8.99219 1.75L3.74819 6.994L0.998188 4.244" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>')`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
  }));

  const [selectedRows, setSelectedRows] = useState([1]);

  const handleCheckboxChange = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((rowIndex) => rowIndex != index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  };

  const [loading, setLoading] = useState(false);

  const handleCloseCheckPending = async () => {
    try {
      setLoading(true);
      let input = {
        propertyId: propertyId,
      };
      const res = await postApiCall(REQUEST_DEPOSIT_DETAILS, input);
      setLoading(false);
      setDepositeopen(false);

      // Success case
      if (res?.data?.status === 1) {
        Swal.fire({
          title: res?.data?.heading || 'Success',
          text: res?.data?.message || 'Deposit Details Requested Successfully',
          icon: 'success',
          confirmButtonText: 'Close',
        });
      }
      // Error case from API
      else {
        Swal.fire({
          title: res?.data?.heading || 'Error',
          text: res?.data?.message || 'Something went wrong',
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }
    } catch (e) {
      setLoading(false);
      // Network or unexpected error
      Swal.fire({
        title: 'Error',
        text:
          e?.response?.data?.message ||
          'Something went wrong. Please try again.',
        icon: 'error',
        confirmButtonText: 'Close',
      });
    }
  };

  const handleViewDepositDetails = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 5000)); // wait 5 seconds
      const input = {
        propertyId: propertyId,
      };
      const res = await postApiCall(BUYER_VIEW_DEPOSIT_DETAILS, input);
    } catch (e) {
      console.error('API call failed:', e);
    }
  };

  useEffect(() => {
    if (userDetail?.primaryUserType == 'Buyer' && open) {
      handleViewDepositDetails();
    }
  }, [open]);

  const [pdfEmbedUrl, setPdfEmbedUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const depositURL = getBuyerIndividualValue?.depositURL;
    setPdfEmbedUrl(depositURL);
  }, [getBuyerIndividualValue]);

  const handleLoad = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  return (
    <>
      {offerPrice == '' ? (
        <Dialog
          open={open}
          PaperProps={{
            sx: {
              borderRadius: '5px',
              width: '100%',
            },
          }}
        >
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: matches900 ? '20px' : '30px',
              gap: '20px',
            }}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '10px' : '14px',
                  color: '#666666',
                }}
              >
                {address}
              </Typography>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
            >
              <OrangePendingwarning matches700={matches700} />
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '16px' : '24px',
                }}
              >
                Request Deposit Details
              </Typography>
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                You have not submitted any offers yet. Please make an offer to
                request deposit payment details.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            sx={{
              padding: matches900 ? '20px' : '30px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              gap: '30px',
            }}
          >
            <Grid item>
              <Button
                onClick={() => setDepositeopen(false)}
                disabled={loading}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => {
                  if (matchessm) {
                    setDepositeopen(false);
                    handleMakeOfferClick();
                    document.documentElement.scrollTo({
                      top: 10,
                      behavior: 'smooth',
                    });
                  } else {
                    setDepositeopen(false);
                    setTabDAta('4');
                    window.scroll({
                      top: 2000,
                      behavior: 'smooth',
                    });
                  }
                }}
                style={{
                  padding: matchessm ? '6px 25px' : '10px 35px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Make Offer
              </Button>
            </Grid>
          </Grid>
        </Dialog>
      ) : data?.depositDetails == null ? (
        <Dialog
          open={open}
          PaperProps={{
            sx: {
              borderRadius: '5px',
              width: matchessm ? '100%' : '600px', // 👈 full width on small, fixed wider width otherwise
              maxWidth: matchessm ? '100%' : '600px',
              margin: matchessm ? 0 : 'auto', // centers on larger screens
            },
          }}
        >
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: matches900 ? '20px' : '30px',
              gap: '20px',
            }}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '10px' : '14px',
                  color: '#666666',
                }}
              >
                {address}
              </Typography>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
            >
              <OrangePendingwarning matches700={matches700} />
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '16px' : '24px',
                }}
              >
                Request Deposit Details
              </Typography>
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                Deposit details are not available at the moment. Please request
                the required information from the Agent.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            sx={{
              padding: matches900 ? '20px' : '30px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              gap: '30px',
            }}
          >
            <Grid item>
              <Button
                onClick={() => setDepositeopen(false)}
                disabled={loading}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={handleCloseCheckPending}
                disabled={loading || offerPrice == ''}
                style={{
                  padding: matchessm ? '6px 25px' : '10px 35px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: offerPrice == '' ? 'gray' : '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Request
              </Button>
            </Grid>
            {loading && (
              <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }} // Slightly smaller
                />
              </Grid>
            )}
          </Grid>
        </Dialog>
      ) : data?.depositDetails != null &&
        Array.isArray(data?.depositOptionDetails) &&
        data?.depositOptionDetails.length == 0 ? (
        <Dialog
          open={open}
          PaperProps={{
            sx: {
              borderRadius: '5px',
              width: '100%',
            },
          }}
        >
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: matches900 ? '10px' : '20px',
              gap: '20px',
            }}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '10px' : '14px',
                  color: '#666666',
                }}
              >
                {address}
              </Typography>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
            >
              <OrangePendingwarning matches700={matches700} />
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '16px' : '24px',
                }}
              >
                Request Deposit Details
              </Typography>
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                Deposit details have already been requested to the Agent.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            sx={{
              padding: matches900 ? '10px' : '20px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              gap: '30px',
            }}
          >
            <Grid item>
              <Button
                onClick={() => setDepositeopen(false)}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Dialog>
      ) : (
        <Dialog
          open={open}
          PaperProps={{
            sx: {
              borderRadius: '5px',
              width: '100%',
              minWidth: matches700 ? '375px' : '895px',
              paddingBottom: matches700 && '40px',
              '& .MuiDialogContent-root': {
                overflow: 'visible',
              },
            },
          }}
        >
          <Grid container height={'100%'}>
            <Grid
              container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: '30px',
                gap: '20px',
              }}
            >
              <Grid item>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    fontSize: matchessm ? '10px' : '14px',
                    color: '#666666',
                  }}
                >
                  {address}
                </Typography>
              </Grid>
              <Grid
                item
                sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
              >
                <Pendingwarning />
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    fontSize: matchessm ? '16px' : '24px',
                  }}
                >
                  Deposit Payment
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  You are about to make the deposit payment for{' '}
                  <Box component="span">
                    <b
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      {address}
                    </b>
                  </Box>
                  .
                </Typography>
              </Grid>
            </Grid>

            <Box sx={{ borderTop: '1px solid lightgrey', width: '100%' }} />

            <Grid
              item
              sx={{
                padding: matches900
                  ? '20px 30px 10px 30px'
                  : '40px 120px 10px 120px',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: { md: '24px', xs: '16px' },
                  fontWeight: 400,
                }}
              >
                Deposit Summary
              </Typography>
            </Grid>

            <Grid
              item
              container
              xs={12}
              sm={12}
              xl={12}
              sx={{
                padding: matches900
                  ? '10px 30px 10px 30px'
                  : '10px 120px 20px 120px',
              }}
            >
              <Grid
                xs={6}
                sm={5}
                xl={4}
                sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
              >
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { md: '16px', xs: '12px' },
                      fontWeight: 400,
                      color: '#666666',
                    }}
                  >
                    Buyer Name:
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { md: '16px', xs: '12px' },
                      fontWeight: 400,
                      color: '#666666',
                    }}
                  >
                    Price:
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { md: '16px', xs: '12px' },
                      fontWeight: 400,
                      color: '#666666',
                    }}
                  >
                    Deposit Amount:
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' },
                      fontWeight: 400,
                      color: '#666666',
                    }}
                  >
                    Deposit Due:
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' },
                      fontWeight: 400,
                      color: '#666666',
                      wordWrap: 'break-word',
                    }}
                  >
                    Proposed Settlement:
                  </Typography>
                </Grid>
              </Grid>

              <Grid
                xs={6}
                sm={7}
                xl={8}
                sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
              >
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { md: '16px', xs: '12px' },
                      fontWeight: 400,
                    }}
                  >
                    {userDetail?.userName} {userDetail?.userSurName}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { md: '16px', xs: '12px' },
                      fontWeight: 400,
                    }}
                  >
                    {data?.depositDetails?.buyerOfferPrice}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { md: '16px', xs: '12px' },
                      fontWeight: 400,
                    }}
                  >
                    {data?.depositDetails?.depositAmount == '$0'
                      ? '-'
                      : data?.depositDetails?.depositAmount}
                  </Typography>
                </Grid>
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' },
                      fontWeight: 400,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <DateIcon matches700={matches700} />{' '}
                    {data?.depositDetails?.dueDate &&
                      dayjs(data.depositDetails.dueDate).format('DD MMMM YYYY')}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' },
                      fontWeight: 400,
                      wordWrap: 'break-word',
                    }}
                  >
                    {data?.depositDetails?.settlementDays}{' '}
                    {data?.depositDetails?.settlementDays === 1
                      ? 'day'
                      : 'days'}{' '}
                    after the exchanged contract date.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: matches900
                  ? '10px 30px 10px 30px'
                  : '20px 120px 10px 120px',
              }}
            >
              <Grid item>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { md: '24px', xs: '16px' },
                    fontWeight: 400,
                  }}
                >
                  Payment Method
                </Typography>
              </Grid>

              <Grid item sx={{ pt: '20px' }}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { md: '16px', xs: '12px' },
                    fontWeight: 400,
                    color: '#666666',
                  }}
                >
                  How would you like to make payment?
                </Typography>
              </Grid>
            </Grid>

            <Grid
              item
              sx={{
                padding: matches900
                  ? '10px 30px 10px 30px'
                  : '10px 120px 10px 120px',
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                maxWidth: '100%',
              }}
            >
              <Table>
                <TableBody>
                  {paymentOptions.map((option, index) => (
                    <TableRow key={index}>
                      <TableCell padding="checkbox">
                        <Typography>
                          <CustomCheckbox
                            checked={selectedRows.includes(index)}
                            onChange={() => handleCheckboxChange(index)}
                            inputProps={{ 'aria-label': `checkbox-${index}` }}
                            disabled={selectedRows.includes(1) && index != 1}
                          />
                        </Typography>
                      </TableCell>
                      <TableCell
                        style={{
                          fontFamily: 'poppins',
                          fontWeight: 400,
                          fontSize: matches900 ? '12px' : '16px',
                          color: '#666666',
                          width: '250px',
                        }}
                      >
                        {option.label}
                      </TableCell>
                      <TableCell
                        style={{
                          fontFamily: 'poppins',
                          fontWeight: 400,
                          fontSize: matches900 ? '10px' : '14px',
                          color: '#666666',
                          width: '250px',
                        }}
                      >
                        {option.description}
                      </TableCell>
                      <TableCell style={{ textAlign: 'right' }}>
                        {option.icon}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid>

            <Grid
              item
              container
              sx={{
                padding: matches900
                  ? '10px 30px 10px 30px'
                  : '40px 30px 20px 120px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                gap: '30px',
              }}
            >
              <Grid item>
                <Button
                  onClick={() => setDepositeopen(false)}
                  variant="outlined"
                  style={{
                    padding: matchessm ? '6px 23px' : '10px 39px',
                    width: '100%',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '15px',
                    color: '#666666',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    borderRadius: '5px',
                    textTransform: 'none',
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  disabled={data?.depositDetails?.unformattedAmount == 0}
                  variant="outlined"
                  style={{
                    padding: matchessm ? '6px 30px' : '10px 50px',
                    width: '100%',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '15px',
                    color: '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    background:
                      data?.depositDetails?.unformattedAmount == 0
                        ? '#b0b0b0ff'
                        : '#4CA4D6',
                    borderRadius: '5px',
                    textTransform: 'none',
                  }}
                  onClick={() => {
                    setSecureOpen(true);
                    setDepositeopen(false);
                  }}
                >
                  Next
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Dialog>
      )}

      <DepositEftPdf
        open={secureOpen}
        setSecureOpen={setSecureOpen}
        setPaymentPop={setPaymentPop}
        setDepositeopen={setDepositeopen}
        getBuyerIndividualValue={getBuyerIndividualValue}
      />
    </>
  );
}
